/**
 * AppKit Wrapper Component
 *
 * This component ensures AppKit is available for child components.
 * AppKit initialization happens in main.tsx, so this is just a pass-through.
 */
import { type ReactNode } from 'react'

interface AppKitWrapperProps {
  children: ReactNode
}

export function AppKitWrapper({ children }: AppKitWrapperProps) {
  // AppKit is initialized in main.tsx, so we just render children
  return <>{children}</>
}
